const angular = require('angular');

class LoginService {
    constructor($rootScope, $q, $window, sessionStorage, Restangular, $state, $stateParams, settings, shopperAnalytics, analytics, shopperService) {
        this._api = Restangular;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.sessionStorage = sessionStorage;
        this.shopperAnalytics = shopperAnalytics;
        this.analytics = analytics;
        this.shopperService = shopperService;

        // Load login prompt message settings
        if (settings.login) {
            this.LoginToViewCategoryMessage = settings.login.loginToViewCategoryMessage;
            this.LoginToSavetoListMessage = settings.login.loginToSavetoListMessage;
            this.LoginToAddRestrictedProductMessage = settings.login.loginToAddRestrictedProductMessage;
            this.LoginToAddMoreProductsMessage = settings.login.loginToAddMoreProductsMessage;
            this.LoginToContinueMessage = settings.login.loginToContinueMessage;
            this.LoginToContinueWhenRememberedMessage = settings.login.loginToContinueWhenRememberedMessage;
            this.LoginToSetDeliveryOrPickupAddressMessage = settings.login.loginToSetDeliveryOrPickupAddressMessage;
            this.LoginToSetDeliveryWindowMessage = settings.login.loginToSetDeliveryWindowMessage;
            this.LoginSessionHasExpiredMessage = 'Please Login. Your Session Has Expired.';
        }
    }

    /**
     * Login function.
     *
     * @param {string} email
     * @param {string} password
     * @param {bool} rememberMe
     * @param {string} [linkToken]
     * @param {string} [userIdFromAgent]
     * @returns
     */
    login(email, password, rememberMe, linkToken, userIdFromAgent) {
        return this._api.one('Login').post('LoginWithCredential', {
            Email: email,
            Password: password,
            RememberMe: rememberMe,
            LinkToken: linkToken,
            UserIdFromAgent: userIdFromAgent,
        })
            .then(loginResult => (loginResult.LoginResult.toLowerCase() === 'success'
                ? this.$q.all([loginResult, this.shopperService.getCurrentShopper(), this.shopperService.getBasicShopperPreferences()])
                : this.$q.all([loginResult])))
            .then(([loginResult]) => {
                this.pushAnalyticsLogin(loginResult.LoginResult.toLowerCase() === 'success');
                return loginResult;
            })
            .then(loginResult => this.onLogin(loginResult));
    }

    onLogin(loginResult) {
        this.$rootScope.$broadcast(`login:${loginResult.LoginResult.toLowerCase()}`, loginResult);

        if (loginResult.LoginResult.toLowerCase() === 'success') {
            this.resolvePromptForLogin(loginResult);
        }

        return loginResult;
    }

    logout() {
        this.$rootScope.$broadcast('logout:start');

        return this._api.one('/').post('Logout').then((response) => {
            if (response.Success === true) {
                this.$window.location.href = '/';
                this.shopperService.IsGuest = true;
            }
        });
    }

    /**
     * Prompt a user for login. Used before performing an action that requires authentication.
     *
     * @param {String} [message] - The message to prompt the user with.
     * @param {State|String} [toState=state.current] - The state which should be navigated to after
     * @param {Object} [toParams=state.params] - The params for the state which should be navigated to after login.
     *  Defaults to the current state params.
     * @param {Object} [stateOptions] - State options for the state which should be navigated to after login.
     * @param {Function} callback - Callback function to call after login success.
     */
    promptForLogin(
        message,
        toState = this.$state.$current,
        toParams = angular.copy(this.$stateParams),
        stateOptions,
        successCallback,
        errorCallback,
        authCallback,
    ) {
        if (this.pendingPromptForLogin) {
            // If there is already a prompt pending, we can return the
            // existing promise for the pending prompt.
            this.pendingPromptForLogin.promise
                .then(() => { if (successCallback) successCallback(); })
                .catch(() => { if (errorCallback) errorCallback(); });
            return;
        }

        this.loginPromptMessage = message;

        const pendingPromptForLogin = this.$q.defer();
        this.pendingPromptForLogin = pendingPromptForLogin;
        this.pendingPromptForLogin.promise
            .then((loginResult) => {
                if (successCallback) {
                    successCallback(loginResult);
                }
            })
            .catch((result) => {
                if (errorCallback) {
                    errorCallback(result);
                }
            })
            .finally(() => {
                if (this.pendingPromptForLogin === pendingPromptForLogin) {
                    this.loginPromptMessage = null;
                    this.pendingPromptForLogin = null;
                }
            });

        this.$state.go('shop.authentication.login', {
            toState, toStateParams: toParams, toStateOptions: stateOptions, customCallback: authCallback,
        });
    }

    resolvePromptForLogin(loginResult) {
        if (this.pendingPromptForLogin != null && loginResult.LoginResult.toLowerCase() === 'success') {
            this.pendingPromptForLogin.resolve(loginResult);
        }

        return loginResult;
    }

    /**
     * If there is an action pending which has prompted for login, this will reject the pending login promise.
     */
    rejectPromptForLogin() {
        if (this.pendingPromptForLogin != null) {
            this.pendingPromptForLogin.reject();
            this.pendingPromptForLogin = null;
        }
    }

    pushAnalyticsLogin(isLoginSuccess) {
        this.shopperAnalytics.push(this.shopperService.shopper);
        this.analytics.push({ data: this.shopperService.shopper, type: this.analytics.mapperTypes.account.login });
        if (isLoginSuccess) {
            // flag for pushing user data to analytics when login
            this.sessionStorage.set('shouldTrackLoginEvent', true);
        }
    }
}


module.exports = LoginService;



// WEBPACK FOOTER //
// ./src/auth/login/login.service.js